module.exports = __webpack_public_path__ + "img/clipboard-file.92b12372.svg";